module.exports = __webpack_public_path__ + "static/img/star3-yellow.838a739a.png";